//⚠️IMPACT attention changer dans le fichier prisma l'enum TeamMemberRole
import { validateEnumTranslations } from '../../safety_checks';

export enum TeamMemberRole {
  OWNER = 'OWNER',
  MANAGER = 'MANAGER',
  RECEPTIONIST = 'RECEPTIONIST',
  EMPLOYEE = 'EMPLOYEE',
  APPRENTICE = 'APPRENTICE',
  VIEWER = 'VIEWER',
}

export const TEAM_MEMBER_ROLE_TRANSLATE_KEY = 'TEAM_MEMBER_ROLE_';

export const TeamMemberRoleTranslation = {
  'fr-FR': {
    [`${TEAM_MEMBER_ROLE_TRANSLATE_KEY}${TeamMemberRole.OWNER}`]: 'Propriétaire',
    [`${TEAM_MEMBER_ROLE_TRANSLATE_KEY}${TeamMemberRole.MANAGER}`]: 'Manager',
    [`${TEAM_MEMBER_ROLE_TRANSLATE_KEY}${TeamMemberRole.RECEPTIONIST}`]: 'Réceptionniste',
    [`${TEAM_MEMBER_ROLE_TRANSLATE_KEY}${TeamMemberRole.EMPLOYEE}`]: 'Employé',
    [`${TEAM_MEMBER_ROLE_TRANSLATE_KEY}${TeamMemberRole.APPRENTICE}`]: 'Apprenti',
    [`${TEAM_MEMBER_ROLE_TRANSLATE_KEY}${TeamMemberRole.VIEWER}`]: 'Consultant',
  },
};

//⚠️IMPACT attention changer dans le fichier prisma l'enum ProfessionalAccessStatus
export enum ProfessionalAccessStatus {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
}

export const PROFESSIONAL_ACCESS_STATUS_TRANSLATE_KEY = 'PROFESSIONAL_ACCESS_STATUS_';

export const ProfessionalAccessStatusTranslation = {
  'fr-FR': {
    [`${PROFESSIONAL_ACCESS_STATUS_TRANSLATE_KEY}${ProfessionalAccessStatus.ACTIVE}`]: 'Actif',
    [`${PROFESSIONAL_ACCESS_STATUS_TRANSLATE_KEY}${ProfessionalAccessStatus.PENDING}`]: 'En attente',
  },
};

validateEnumTranslations(TeamMemberRole, TeamMemberRoleTranslation, TEAM_MEMBER_ROLE_TRANSLATE_KEY, true);
validateEnumTranslations(
  ProfessionalAccessStatus,
  ProfessionalAccessStatusTranslation,
  PROFESSIONAL_ACCESS_STATUS_TRANSLATE_KEY,
  true,
);
